<template>
   <div :class="`user--list user--list-${listSorted && listSorted.length > 0 ? 'active' : ''} user--list-${direction ? 'right' : 'left'}`">

    <div v-if="!direction && detectLeftNeighbour()" class="user--list-person user--list-person-percent" :style="`opacity: 0.2; transform: translate3d(${calcPosition(0) * 1.65}px, 0, 0) scale(0.77); z-index: 0;`" @click="updateUser(detectLeftNeighbour().id)">
      <router-link :to="`${calcLink(category)}/accounts/${ detectLeftNeighbour().id }/`">
        <div class="user--avatar-preview">{{ detectLeftNeighbourCompare() || 0}}%</div>
      </router-link>
    </div>

    <div v-for="men, key in listSorted" :key="men.id" @click="updateUser(men.id)" :class="['user--list-person', {'user--list-tema': tema === men.id}]" :style="`opacity: ${calcOpacity(key)};transform: translate3d(${calcPosition(key)}px, 0, 0) scale(${calcScale(key)}); z-index: ${calcZindex(key)};`">
      <router-link :to="`${calcLink(category)}/accounts/${men.id}/`">
        <img v-if="men.profile_photo" :src="men.profile_photo"/>
        <div v-else-if="men.first_name" :style="`background: ${calcColor(men.compare_etalon)}`" class="user--avatar-preview">{{ men.first_name[0] }}{{ men.last_name[0] }}</div>
      </router-link>
    </div>

    <div v-if="direction && listSorted.length > limit && detectRightNeighbour()" class="user--list-person user--list-person-100" :style="`opacity: 0.2; transform: translate3d(${calcPosition(listSorted.length - 1) * 1.5}px, 0, 0) scale(0.77); z-index: 1;`" @click="updateUser(detectRightNeighbour().id)">
      <router-link :to="`${calcLink(category)}/accounts/${ detectRightNeighbour().id }/`">
        <div class="user--avatar-preview">{{ detectRightNeighbour().compare_etalon }}%</div>
      </router-link>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';


import colorLibrary from '@/utils/colorLibrary';

export default {
  name: 'UserList',
  props: ['direction'],
  computed: {
    ...mapGetters(['persons', 'person', 'tema', 'dev', 'category']),
  },
  data() {
    return {
      listSorted: [],
      listReverse: [],
      limit: 8,
    };
  },
  watch: {
    persons() {
      this.listSorted = this.list();
    },
  },
  mounted() {
    this.listSorted = this.list();
    if (this.dev) {
      this.limit = 4;
    }
  },
  methods: {
    detectLeftNeighbour() {
      let leftNeigbour = this.listSorted[0];

      if (this.person.left_neighbor && this.person.left_neighbor.compare_etalon > 0) {
        leftNeigbour = this.person.left_neighbor;
      }

      return leftNeigbour;
    },

    detectLeftNeighbourCompare() {
      let compare = this.listSorted[0] ? this.listSorted[0].compare_etalon : 0;
      if (this.person.compare_tags && this.category !== '') {
        for (let tag = 0; tag < this.person.compare_tags.length; tag += 1) {
          const tagCurr = this.person.compare_tags[tag];
          if (tagCurr.tag === this.category) {
            compare = tagCurr.value - 5;
          }
        }
      }

      return compare;
    },

    detectRightNeighbour() {
      let rightNeigbour = {
        compare_etalon: 100,
        id: this.tema,
      };
      if (this.category === '' && this.person.right_neighbor && this.person.right_neighbor.compare_etalon > 0) {
        rightNeigbour = this.person.right_neighbor;
      }
      return rightNeigbour;
    },

    updateUser(userId) {
      this.$store.commit(types.CLEAR_PERSONS);
      setTimeout(() => {
        this.$store.dispatch('fetchPerson', userId);
      }, 200);
    },
    list() {
      const list = this.persons.results ? this.persons.results.slice(0) : [];
      if (list && list.length > 0) {
        this.listReverse = list.reverse();
        const listFiltered = [];

        for (let p = 0; p < this.listReverse.length; p += 1) {
          if (this.listReverse[p].id && this.checkUsersDirection(this.listReverse[p], p)) {
            listFiltered.push(this.listReverse[p]);
          }
        }
        return listFiltered;
      }
      return [];
    },
    calcColor(coeff) {
      return colorLibrary(coeff).top;
    },
    calcOpacity(key) {
      if (this.listSorted && this.listSorted.length > 4) {
        if (this.direction) {
          return this.getOpacity(this.listSorted.length - key);
        } else if (!this.direction && key < 3) {
          return this.getOpacity(key + 1);
        }
      }
      return 1;
    },
    calcPosition(key) {
      if (this.listSorted && this.listSorted.length > 4) {
        const position = key + 1;
        const positionCoeff = 5;
        if (this.direction) {
          return -(position * positionCoeff) / ((this.listSorted.length - position) + 1);
        } else if (!this.direction) {
          return ((this.listSorted.length - key) * positionCoeff) / position;
        }
      }
      return 0;
    },
    calcScale(key) {
      if (this.listSorted && this.listSorted.length > 4) {
        if (this.direction) {
          if (key === this.listSorted.length - 1) return 0.85;
          if (key === this.listSorted.length - 2) return 0.9;
        } else if (!this.direction) {
          if (key === 0) return 0.8;
          if (key === 1) return 0.9;
        }
      }
      return 1;
    },
    calcPercentColor(coeff) {
      return `rgb(${252 - coeff},${100 + Math.floor(coeff * 1.1)},${20 + Math.floor(coeff / 10)})`;
    },
    calcZindex(key) {
      return this.direction ? (this.listSorted.length + 1) - key : key;
    },
    getPosition(value) {
      switch (value) {
        case 1:
          return 50;
        case 2:
          return 25;
        case 3:
          return 0;
        default:
          return 0;
      }
    },
    getOpacity(value) {
      switch (value) {
        case 1:
          return 0.3;
        case 2:
          return 0.6;
        case 3:
          return 0.8;
        default:
          return 1;
      }
    },
    calcLink(category) {
      const cat = category === '' ? '' : `/${category}`;
      return cat;
    },
    checkUsersDirection(men, key) {
      const isTema = this.tema === men.id;
      const currentPersonPosition = this.listReverse.findIndex(x => x.id === this.person.id) || 10;
      const comparePositions = currentPersonPosition > key;
      const isLeft = comparePositions && !this.direction && !isTema;
      const isRight = (!comparePositions && this.direction) || isTema;

      return this.person.id !== men.id && (isLeft || isRight);
    },
  },
};
</script>

<style>
.user{
  &--list{
    transition: all .5s ease-in-out;
    white-space: nowrap;
    opacity: 0;
    width: 33%;
    &-active{
      opacity: 1;
    }

    &,
    &-person{
      display: inline-block;
      vertical-align: top;
      user-select: none;
      margin: 0 5px;

      .user--avatar-preview,
      img{
        border-radius: 50%;
        color: white;
        height: auto;
        width: 40px;
      }

      .user--avatar-preview{
        text-align: center;
        line-height: 2.7;
        font-size: 100%;
        height: 40px;
      }
    }

    &-right{
      text-align: left;
    }
    &-left{
      text-align: right;
      .user--list-tema {
        display: none;
      }
    }

    &-person{
      transition: all .3s ease-in-out;
      filter: grayscale(1);
      position: relative;
      opacity: .8;

      &:hover{
        z-index: 99 !important;
        opacity: 1 !important;
        filter: grayscale(0);
      }

      &-100,
      &-percent{
        .user--avatar-preview{
          background: white;
          color: black;
        }
      }

      &-100{
        font-size: 90%;
        .user--avatar-preview{
          line-height: 3;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// List.vue?062808d2